import useTranslation from 'next-translate/useTranslation'
import { useEffect, useState } from 'react'

import BodyText from '../../../../app/components/BodyText'

function CopyrightNotice() {
  const { t } = useTranslation('generated')

  const [year, setYear] = useState<number | null>(null)

  useEffect(() => {
    // Set the year after mount to avoid SSR hydration mismatches when the
    // prerendered HTML was built in a previous year (AI-25090)
    setYear(new Date().getFullYear())
  }, [])

  return (
    <BodyText color="body-1">
      © {year} {t('copyrightBrandName')}
    </BodyText>
  )
}

export default CopyrightNotice
